export const PRICING_LEAD = "Subscriptions, per site per month, plus one-time setup per site:";

export const TIER_LINES = [
  {
    name: "Core",
    line: "$1,500/site/month + $5,000 setup. Includes WSafe AI, HazardLoop, WorkSafeStory.",
  },
  {
    name: "Pro",
    line: "$3,000/site/month + $10,000 setup. Includes everything in Core plus InductIQ and EnviSafe.",
  },
  {
    name: "Vision",
    line: "$6,250/site/month + $25,000 setup. Includes everything in Pro plus SafeForm and continuous CCTV detection.",
  },
];

export const PILOT_LINE = "$1,000, no install fee.";

export const COMPLIANCE_TEXT =
  "$1,500 evaluation; then Essentials $500, Standard $1,000 or Premium $2,000 per site/month, billed in addition to a Core or Pro subscription. Covers OSHA and environmental records. Documentation setup is included in the setup fee; work beyond included hours is $150/hr.";

export const CONSULTING_TEXT =
  "$150/hr; $1,500 gap review; $1,500/day audit; $2,500 AI readiness assessment (credited toward a paid pilot); $1,200/month retainer. No travel charge for on-site work within 50 miles of Abilene, Texas.";
